import { render } from "./Dashboard.vue?vue&type=template&id=6f5c5d82&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=6f5c5d82&scoped=true&lang=css"

import exportComponent from "E:\\Project Repository\\11-Isomat\\code\\services\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5c5d82"]])

export default __exports__